import React, { createContext, useCallback, useContext, useState } from 'react';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

export interface IAlert {
  message: string;
  duration?: number;
  severity?: Severity;
}

interface IAlertCtx {
  alert: null | IAlert;
  showAlert: (alert: IAlert) => void;
  hideAlert: () => void;
}

export enum Severity {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

const AlertCtx = createContext<IAlertCtx>({
  alert: null,
  showAlert: () => {},
  hideAlert: () => {},
});

export function useAlert() {
  return useContext(AlertCtx);
}

const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState<null | IAlert>(null);
  const { message = '', duration = 3000, severity = Severity.Success } = alert || {};

  const showAlert = useCallback((alert) => setAlert(alert), []);
  const hideAlert = useCallback((event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setAlert(null);
  }, []);

  return (
    <AlertCtx.Provider value={{ showAlert, hideAlert, alert }}>
      {children}
      <Snackbar open={Boolean(message)} autoHideDuration={duration} onClose={hideAlert}>
        <MuiAlert onClose={hideAlert} severity={severity} variant="filled" elevation={6}>
          {message}
        </MuiAlert>
      </Snackbar>
    </AlertCtx.Provider>
  );
};

export default AlertProvider;
